export class CreditRequestContactInformation {
    Cargo_Contacto: string;
    Celular: string;
    Correo_Electronico: string;
    Primer_Apellido: string;
    Primer_Nombre: string;
    Segundo_Apellido: string;
    Segundo_Nombre: string;
    Telefono: string;
    Telefono_Extension: string;
    objIdContacto: string;
    valid: boolean;

    constructor() {
        this.Cargo_Contacto = "";
        this.Celular = "";
        this.Correo_Electronico = "";
        this.Primer_Apellido = "";
        this.Primer_Nombre = "";
        this.Segundo_Apellido = "";
        this.Segundo_Nombre = "";
        this.Telefono = "";
        this.Telefono_Extension = "";
        this.objIdContacto = "";
        this.valid = false;
    }
}